module.exports = __webpack_public_path__ + "img/invoice-ch-male.8131e4e4.png";